export default {
  "查看全部x个作品": "View all <i class='n'>{count}</i> works",
  "x的活动": "{name}’s Events",
  "x的直播": "{name}’s Lives",
  "作品收录于": "Featured in Channels",
  "x件作品被收录": "{count} works featured in",
  "共x个作品": "{count} Works",
  "喜欢": "Likes",
  "发布的作品": "My Works",
  "发布的文章": "My Articles",
  "关注的频道": "My Channels",
  "喜欢的作品": "My Liked Works",
  "发布的活动": "My Events",
  "喜欢的文章": "My Liked Articles",
  "还没有发布的内容": "No Works",
  "还没有发布的文章": "No Articles",
  "还没有关注": "No Following",
  "还没有粉丝": "No Followers",
  "还没有喜欢的作品": "No Liked Works",
  "还没有喜欢的文章": "No Liked Articles",
  "更换背景图": "Replace banner image",
  "图片尺寸不小于1440*250px": "Minimal dimensions should be 1440*250px",
  "分享到其它平台": "Share to",
  "拖动背景以调整图片位置": "Drag banner image to reposition",


  "艺术/设计/科技 跨界创新": "Art / Design / Technology  Cross-industry Innovation",
  "MANA公众号": "Official Account",
  "没有更多了": "END",
  "请": "Please ",
  "文章预览": "Preview",
  "视频上传中": "Video Uploading...",
  "视频上传失败": "Video Upload Fail",

  "账户设置": "Setting",
  "草稿已保存": "Saved",
  "草稿保存中…": "Saving…",
  "查看全部x条回复": "View All {count} comments",
  "共x条评论": "{count} comments",
  "发表您的评论…": "Add a comment…",
  "还没有评论": "No comment",
  "发表评论": "Add comment",
  "搜索作品、创作者、文章": "Search works, creators, articles",
  "写文章": "Write an article",
  "频道": "Channels",
  "项目": "Projects",
  "返回编辑": "Edit",
  "草稿": "Draft",
  "我的文章": "My articles",
  "再发表评论": " to comment",

  "请选中排序创作者": "Unselect",
  "图片大小至少280 * 280像素，支持JPG、PNG、GIF等格式，图片需小于5M": "Image should be bigger than 280 * 280 px, less than 5M,  JPG/PNG/GIF supported.",
  "图片大小至少2320 * 660像素，支持JPG、PNG、GIF等格式，图片需小于5M": "Image should be bigger than 2320 * 660 px, less than 5M,  JPG/PNG/GIF supported.",
  "英文名称": "English Name",
  "英文简介": "English Intro",
  "该频道还没有相关活动": "No Activity",
  "还没有成员于此频道发布文章": "No Article",
  "该频道还没有相关文章": "No Article",
  "共有x个成员于此频道发布文章": "{count} Article Writers",
  "共x个创作者": "{count} creators",
  "共x个成员": "{count} members",
  "共x篇文章": "{count} articles",
  "共x个视频": "{count} videos",
  "共x个活动": "{count} events",
  "加载中": "Loading more",
  "重新加载": "Reload",
  "加载出错，请检查网络连接": "Error. Please check your Internet connection.",

  "最新排序": "Latest",
  "热门排序": "Popular",
  "共x位成员": "{count} followers",

  "注": "Notice",
  "毕业/所在院校": "University",
  "请填写QQ号": "Please input your QQ ID",
  "个": "",
  "请将手机号": "Please keep your phone number ",
  "补充完整": " complete",
  "请将邮箱": "please keep your email ",
  "请先完善个人资料": "Please complete your profile",
  "请填写个性签名": "Please enter about",
  "请填写个人简介": "Please enter bio",
  "请上传头像": "Please upload the avatar",
  "请选择性别": "Please select the gender",
  "请选择创作领域": "Please select a creative field",
  "该标签已存在": "This tag already exists",
  "通过": "Pass",
  "已售罄": "Sold out",
  "售卖中": "On sale",
  "尚未开始": "Coming soon",
  "暂停售卖": "Pause",
  "新建": "New",
  "下架": "Discontinue",
  "上架": "Resume",
  "其他平台售票": "Other platform",
  "其他平台免费报名": "Free registration w/ other platform",
  "无需报名": "Onsite check-in",
  "开始时间不能大于结束时间": "Start time should be ealier than end time",
  "确定要将这个票种": "Do you confirm to put ticket as ",
  "成功": "Success",
  "已取消": "Canceled",
  "报名结束时间不可晚于举办结束时间": "Registration end time can't be later than event end time",
  "请上传视频或选择已发布作品": "Please upload a video or select from uploaded videos",

  "申请合作": "Apply for partnership",
  "我要发布项目需求": "Publish a demand",
  "详细说明": "Details",
  "需求截止日期": "Ending date",
  "项目预算": "Project budget",
  "项目周期": "Time span",
  "开始时间": "Start time",
  "项目阶段": "Project stage",
  "项目地点": "Location",
  "需求方类型": "Demander type",
  "查看联系方式": "View contacts",
  "你尚未认证": "Verify your identity first",
  "为保证信息安全": "For security concerns",
  "请先进行个人或企业认证": "please verify your personal or corporate identity",
  "去认证": "Verify",
  "需求名称": "Demand title",
  "电话": "Mobile",
  "微信号": "WeChat ID",
  "复制成功": "Copied",
  "免费": "Free",
  "编辑门票": "Edit the ticket",
  "售卖结束时间": "Deals ends at",
  "结束时间": "Ends at",
  "请输入报名": "Please enter to register",
  "免费下载": "Free download",
  "设置 banner": "Banners",
  "共": "",
  "上传视频，即表示您已同意MANA上传服务条款，请勿上传色情，反动等违法视频": "By clicking to upload, you agree to MANA's terms, and porn & violence related videos are forbidden",
  "并同意遵守": "Approv to follow",
  "MANA原创/授权视频声明用户规范": "MANA Term of use",
  "《MANA法律责任》": "MANA Disclaimer",
  "请输入举报内容，我们将尽快处理。": "Please enter a reason to get prompt response",
  "次": " views",
  "活动类型": "Event type",
  "票种信息": "Ticket type",
  "票种名称": "Name",
  "数量": "Qty.",
  "最大购买数量": "Max/person",
  "售卖开始时间": "Deal starts at",
  "售卖截止时间": "Deal ends at",
  "售卖状态": "State",
  "暂无数据": "Data not available",
  "添加免费票": "Add a ticket",
  "补充说明": "Notes",
  "请填写售卖结束时间": "Please enter deal end time",
  "请填写售卖开始时间": "Please enter deal start time",
  "请填写活动名称": "Please enter event title",
  "请填写数量": "Please enter quanity",
  "请填写最大购买数量": "Please enter max tickets per person",
  "请选择报名时间": "Please select registration time",
  "请选择举办时间": "Please select event time",
  "格式jpeg、png，文件大小≤3MB，图片比例3:4，尺寸≥360*480": "jpeg, png accepted, filesize≤3MB, aspect ratio 3:4, size≥360*480",
  "APP下载": "App",
  "项目对接": "Projects",
  "招聘": "Jobs",
  "发布招聘信息": "Post a job",
  "搜索感兴趣的视频，创作者，活动": "Search for videos, creators & activities",
  "已经有MANA账户了吗，": "Already have an account?",
  "还没有MANA账户，": "New to MANA?",
  "3G以内": "3G at most",
  "操作": "Action",
  "国 家": "Country",
  "认 证": "Identity",
  "论坛等": "Forum etc.",
  "邮   箱": "Email",
  "年/月/日": "yyyy/mm/dd",
  "即日起至": "Up till ",
  "可多选": "multiple",
  "2019“现未来”科技艺术之星奖组委会": "2019 \"Present Future\" Art & Technology Star Award Organization committee",
  "2019“现未来”科技艺术之星奖": "2019 \"Present Future\" Art & Technology Star Award| MANA",
  "手机号登录": "SMS",
  "账号密码登录": "Password",
  "手机号或邮箱": "Phone or email",
  "高校信息": "University",
  "生日": "Birthday",
  "地址": "Address",
  "性别": "Gender",
  "创作领域": "Creative fields",
  "社交账户": "Social Accounts",
  "社交": "Social",
  "个人介绍": "Bio",
  "个人/团队介绍": "Intro",
  "企业名称": "Company",
  "艺术": "Arts",
  "科技": "Science & Technology",
  "致力于公共艺术互动装置的设计与新媒体艺术的应用": "dedicated to the design of public art & interactive design as well as the application of new media art",
  "账户链接": "Links",
  "千核科技": "GeeksArt",
  "广州": "Guangzhou",
  "上海": "Shanghai",
  "武汉": "Wuhan",
  "微信公众号": "Official Wechat account",
  "等": "etc.",
  "分享": "Share",
  "图片截取": "Image crop",
  "对象": "Object",
  "个人信息": "Personal info",
  "地区": "Region",
  "上传图片": "Upload",
  "是否允许带": "Whether allow to take",
  "这些": "these",
  "请求发起前拦截器": "Request for interceptor",
  "全局": "Global",
  "状态": "State",
  "触发": "Trigger",
  "效果": "Effect",
  "请求参数处理成": "Request parameter to process in",
  "方法所需的格式": "Required format for method",
  "异常处理": "Exception handling",
  "响应拦截": "Interceptor response",
  "关闭": "Close",
  "您的账号已在其他地方登录": "Your account's logged in other than current location",
  "您确定要重新登录吗": "Confirm to log back in",
  "确定事件": "Confirmed event",
  "取消": "Cancel",
  "取 消": "Cancel",
  "删除当前用户登录信息": "Remove all current use login info",
  "中文跳英文": "Redirect to English site",
  "日期问题": "Date issue",
  "时间戳转时间": "Timestamp to time",
  "去掉所有的": "Remove all",
  "标记": "tags",
  "判断是否是": "Check if it's",
  "标签": "Tags",
  "跳移动端": "Redirect to mobile site",
  "讨论区": "Discussions",
  "视频详情页": "Video details",
  "频道详情页": "Channel details",
  "登陆页面": "Login page",
  "认证页面": "Verification page",
  "个人中心": "My account",
  "中文版": "Chinese",
  "在这里塞入": "Insert here",
  "表单": "form",
  "选中列表": "selected list",
  "类别列表": "category list",
  "是否单选": "Singular selection or not",
  "是否显示全部": "Show all or not",
  "全部": "All",
  "全 部": "All",
  "菜单分类": "Menu category",
  "关于": "About ",
  "关于我们": "About us",
  "用户协议": "Term of use",
  "认证合作艺术家": "Verified artists",
  "免责声明": "Disclaimer ",
  "侵权申诉": "Tort claims ",
  "帮助中心": "Help center",
  "吗呐": "MANA",
  "添加到频道": "Add to Channel",
  "推荐到频道": "Recommend to channel",
  "还未关注频道": "You haven't followed any channel",
  "还未创建频道": "You haven't created any channel",
  "确认添加": "Confirm",
  "我创建和我": "I created and",
  "加入的": "joined",
  "我的频道组": "My channels",
  "请选择频道": "Please choose a channel",
  "添加成功": "Successfully added",
  "操作成功，请等待审核": "Operation succeeded, please wait for review",
  "交互": "Interactive",
  "数字艺术": "Digital art",
  "视频": "Videos",
  "视 频": "Video",
  "成员": "Members",
  "我关注的": "Following",
  "我创建的": "Created by me",
  "取消关注频道后": "After unfollow the channel",
  "将收不到频道内任何内容": "you wouldn't receive any notification from the channel",
  "取消关注": "Unfollow",
  "确定": "Confirm",
  "确 定": "Confirm",
  "删除成功": "Successfully deleted",
  "没有加入的频道": "You haven't joined any channel",
  "没有创建的频道": "You haven't created any channel",
  "修改头像": "Update",
  "选择图片": "Choose an image",
  "不允许改变已设置的裁图宽高": "Width and height can't be changed",
  "只有自动截图开启": "only after auto-crop's enabled",
  "宽度高度才生效": "width & height becomes effective",
  "文件大小不能小于": "Minimum file size",
  "个人主页": "Profile",
  "我的账户": "My account",
  "申请认证": "Apply for verification",
  "管理视频": "My videos",
  "播放记录": "Watch history",
  "我的收藏": "My collection",
  "我的点赞": "Liked videos",
  "我的关注": "Following",
  "我的粉丝": "My followers",
  "我的频道": "My channels",
  "我的活动": "My events",
  "我的竞赛": "My contests",
  "退出登录": "Log out",
  "只是起到注解作用": "just as a comment",
  "不让文本换行": "wouldn't change line",
  "超出的部分显示": "show the exceeded parts",
  "报名参加": "Enroll",
  "上传作品": "Upload",
  "举办方简介": "Host intro",
  "全球艺术网络科技": "Global art network technology",
  "展开": "Unfold",
  "时间": "Time",
  "报名时间": "Enroll time",
  "举办时间": "Event time",
  "频道简介": "Intro",
  "行业": "Industries",
  "行 业": "Industries",
  "专业": "Professions",
  "专 业": "Professions",
  "关注该频道": "Follow the channel",
  "频道信息": "Channel info",
  "频道内共有": "In this channel, there're",
  "个视频": "videos",
  "其中组员推荐的视频有": "videos recommended by members",
  "设置频道": "Edit",
  "本频道共有": "in this channel",
  "个成员": " members",
  "收起": " Show less",
  "加入成功": "Joined",
  "进行中": "Current",
  "至": " to ",
  "链接": "Link",
  "线上活动": "Online",
  "线下活动": "Offline",
  "竞赛": "Contest",
  "全球新媒体艺术平台": "Global new media art platform",
  "设计": "Design",
  "跨界创新": "Cross-field innovation",
  "登录": "Log in ",
  "或": " or ",
  "注册": "Register",
  "说说你的看法": "Share your views",
  "留点足迹": "Leave a comment",
  "评论": "Comments",
  "全部评论": "See all",
  "举报": "Report",
  "请输入回复内容": "Please enter to reply",
  "回复": "Reply",
  "查看更多": "See more",
  "回复内容不能为空": "Empty reply not allowed",
  "回复内容不能超过": "Reply should not exceed",
  "字": "characters",
  "暂无其他更多": "You've reached the bottom",
  "全部通知": "All notifications",
  "点赞": "Like",
  "关注": "Follow",
  "关 注": "Follow",
  "+关注": "+ Follow",
  "活动": "Events",
  "系统": "System",
  "下载": "Download",
  "2017年数码艺术奖项“流明艺术”作品征集开启！": "2017 Digital Art Prize \"Lumen Arts\" open for enrollment!",
  "数码艺术": "Digital art",
  "竞赛介绍": "Introduction",
  "全部作品": "All works",
  "参赛人员": "Enrolled",
  "我的作品": "My creative",
  "获奖作品": "Winning entries",
  "关于主办方": "About the host",
  "新媒体艺术": "New media art",
  "创意技术": "Creative technology",
  "分类": "Category",
  "腾讯安全": "Tencent security",
  "艺术影像": "Art graphics",
  "取消收藏": "Remove",
  "最新发布": "Latest",
  "浏览最多": "Views",
  "点赞最多": "Likes",
  "成为认证合作艺术家": "Apply to be verified artist",
  "立即申请": "Apply now",
  "填写报名信息": "Fill in registration info",
  "报名参赛须知": "Contest disclaimer",
  "姓名": "Name",
  "必填项": "Required",
  "年龄": "Age",
  "手机号": "Mobile",
  "用于通知": "Used for notification",
  "不会泄露您个人信息": "won't uncover your personal info",
  "职业": "Occupation",
  "提交": "Submit",
  "提 交": "Submit",
  "广告公关": "Public relation",
  "新闻媒体": "News media",
  "教育培训": "Education",
  "金融投资": "Finance",
  "建筑业": "Construction",
  "房地产业": "Real estate",
  "旅游餐饮": "Catering",
  "学生": "Students",
  "其他": "Other",
  "全球艺术网络科技公司": "Global art network technology company",
  "公司简介": "Introduction",
  "联系": "Contact",
  "作品名称": "Name of the work",
  "请输入您的作品名字": "Please enter the name of the work",
  "视频简介": "Introduction",
  "上传参赛视频": "Upload ",
  "上传作品封面": "Upload cover image",
  "为必填内容": "Required",
  "真实姓名": "Name",
  "选择领域": "Choose a field",
  "手机号码": "Mobile",
  "常用邮箱": "Email",
  "在线作品链接": "Url to your work",
  "可选": "Optional",
  "上传您的简历": "Upload your resume",
  "上传简历": "Upload",
  "文件正在上传": "The file's being uploaded",
  "提交审核": "Submit for verification",
  "创建": "Create",
  "已上传": "Uploaded",
  "文件上传成功": "File was successfully uploaded",
  "奖励": "Reward",
  "元": "Yuan",
  "敬请期待": "coming soon",
  "通用状态": "General state",
  "待审核": "Pending review",
  "审核未通过": "Verification failed",
  "已结束": "Finished",
  "保密": "Secret",
  "男": "Male",
  "女": "Female",
  "暂无": "None",
  "首页": "Home",
  "发现": "Explore",
  "创作者": "Creators",
  "学习": "Study",
  "高校": "College",
  "搜索": "Search",
  "上传": "Upload",
  "上 传": "Upload",
  "消息": "Message",
  "我的主页": "Profile",
  "请输入搜索内容": "Please enter to search",
  "是否认证": "Verified",
  "是": "Yes",
  "否": "No",
  "头像": "Profile image",
  "作品集": "Collection",
  "动态图像设计": "Dynamic graph design",
  "用户体验": "User experience",
  "简介": "Intro",
  "最新创作": "Latest",
  "按浏览量": "Sort by views",
  "按点赞数": "Sort by likes",
  "按评论数": "Sort by comments",
  "视频名称": "Video title",
  "领域": "Fields",
  "左箭头": "Left arrow",
  "右箭头": "right arrow",
  "禁用向下箭头": "Down arrow is forbidden",
  "禁用向上箭头": "Up arrow is forbidden",
  "粉丝": "Follower",
  "作品": "Works",
  "请填写举报理由": "The reason your report",
  "涉及黄赌毒和暴力": "Porn or violence related",
  "政治": "Political",
  "版权问题": "Copyright",
  "抄袭": "Plagiarize",
  "也可发邮件给我们": "You may also email",
  "执行举报": "Submit",
  "举报成功": "Reported",
  "举报失败": "Failed to report",
  "姓名不能为空": "Name required",
  "手机号不能为空": "Mobile required",
  "请输入正确的手机号": "Please enter correct phone number",
  "请输入正确的年龄": "Please enter correct age",
  "请选择职业": "Please select your occupation",
  "活动介绍": "Description",
  "报名人员": "Enrolled",
  "活动照片": "Event photos",
  "咨询赛事与商务合作，请直接拨打我们的电话或者填写表单，我们将在第一时间响应。": "For contest consulting or business cooperation, please call us or submit the form!",
  "联系人": "Contact",
  "座机号": "Telephon",
  "邮箱": "Email",
  "公司名称": "Company name",
  "请输入公司名称": "Please enter your company name",
  "请输入联系人": "Please enter the contact",
  "联系电话": "Contact phone",
  "请输入联系电话": "Please enter the contact phone no.",
  "电子邮箱": "Email",
  "请输入电子邮箱": "Please enter the email",
  "详细需求": "Detailed requests",
  "请输入详细需求": "Please enter detailed requests",
  "联系人名字": "Contact",
  "很抱歉": "Sorry!",
  "你访问的页面不存在": "We cannot find the page you requested! ",
  "输入的地址有误或该地址已被删除": "The url you're visiting is missing or removed",
  "返回首页": "Back to home",
  "下一步": "Next",
  "选择已发布作品": "Choose from published works",
  "第三方账号绑定": "Link to 3rd party accounts",
  "确认解绑": "Confirm",
  "暂不解绑": "Cancel",
  "申请合并这些账号": "Apply to merge these accounts",
  "选择发布类型": "Select the published type",
  "展览": "Exhibition",
  "演出": "Show",
  "展览、演出、论坛等论坛等": "Exhibition, show & forum etc.",
  "作品征集等": "Collect creatives etc.",
  "请选择发布类型": "Please choose a publishing type",
  "绑定手机号": "Add a phone number",
  "请选择区号": "Please select area code",
  "输入手机号": "Please enter your mobile",
  "验证码": "Verification code",
  "获取验证码": "Send code",
  "后重新获取": "later",
  "绑定": "Link",
  "已绑定成功": "Successfully linked",
  "手机号未被绑定第三方": "The mobile phone hasn't linked a 3rd party account",
  "这个手机号已经绑定其他账户": "This number's already connected to other accounts",
  "手机号已被绑定第三方": "This number's linked to a social account",
  "这个手机号已经绑定其他三方账号": "This number's linked to a social account",
  "昵称重复": "Duplicate nickname",
  "请修改昵称": "please change a nickname",
  "验证码已发送": "Authentication code was sent",
  "请输入绑定的账号": "Please enter the account you wish to connect",
  "已选条件": "Filters",
  "专业类别": "Professions",
  "认证": "Verified",
  "非认证": "Unverified",
  "国家": "Country",
  "北京": "Beijing",
  "深圳": "Shenzhen",
  "列表": "List",
  "提交作品": "Submit",
  "导航栏": "Navigation bar",
  "完善个人资料": "Complete your info",
  "填写参赛信息": "Submit contest info",
  "支付费用": "Pay",
  "国际": "international",
  "非国际": "domestic",
  "填写竞赛投稿信息": "Fill in contest info",
  "投稿作品": " Work",
  "编辑": "Edit",
  "作品标题": "Video title",
  "英文": "English",
  "作品简介": "Introduction",
  "作品图片": "Images",
  "至少上传": "At least upload",
  "删除": "Delete",
  "请上传图片": "Please upload images",
  "参赛类别": "Contest type",
  "请选择参赛类别": "Please select contest type",
  "参赛方式": "Contest party",
  "个人": "Individual",
  "团队": "Team",
  "投稿代表同意参赛条款": "Upon submitting your work, you agree to the contest terms",
  "请输入作品标题": "Please enter the title",
  "请输入作品简介": "Please enter the description",
  "请选择参赛方式": "Please select the contest party",
  "参赛条款及细则": "Rules & terms",
  "张作品": "pieces of work",
  "张": "pieces",
  "投稿成功": "Work submitted",
  "获奖公示": "Winners",
  "入围作品": "Entries",
  "参赛作品": "Submitted works",
  "sumbitWorks": "Submitted works",
  "立即报名": "Enroll Now",
  "同意并立即报名": "Agree and enroll Now",
  "不同意": "Disagree",
  "投稿中": "In progress",
  "评审中": "Reviewing",
  "结束": "Finished",
  "近期事件": "Latest Events",
  "链接已经失效": "The link has expired",
  "视频加载中": "Loading",
  "请稍后": "please be patient",
  "重置密码": "Reset password",
  "密码": "Password",
  "确认密码": "Password again",
  "用户服务协议": "Term of use",
  "直接登录": "Log in now",
  "两次输入的密码不一致": "Passwords must match",
  "文件不能大于3G": "Maximum file size: 3G",
  "标题": "Title",
  "粗体": "Bold",
  "字号": "Font size",
  "字体": "Font",
  "斜体": "Italic",
  "下划线": "Underline",
  "文字颜色": "Font color",
  "背景颜色": "Background color",
  "插入链接": "Insert link",
  "对齐方式": "Alignment",
  "引用": "Quote",
  "表情": "Emoji",
  "插入图片": "Insert image",
  "插入视频": "Insert video",
  "表格": "table",
  "撤销": "cancel",
  "重复": "repeat",
  "默认": "default",
  "内容": "Content",
  "左侧菜单栏": "Left menu",
  "全部院校": "All universities",
  "获取数据": "Fetch data",
  "发布文章": "Publish article",
  "发布问答": "Post a question",
  "发布": "Publish",
  "请输入标题": "Please enter the title",
  "最多": "At most",
  "个字": " characters",
  "请输入问题": "Please enter your question",
  "获取当前问题": "Get the current question",
  "标题不能为空": "Title's required",
  "内容不能为空": "Main content's required",
  "内容不得少于": "The content should be more than",
  "违禁": "forbidden",
  "存在违禁词": "Prohibited words included",
  "建议人工复审": "A manual verification should be involved",
  "发布成功": "Published",
  "请等待审核": "Please wait for verification",
  "日程表": "Schedule",
  "预售票购买": "Presale",
  "论坛介绍": "Introduction",
  "本届嘉宾": "Guests",
  "商务合作": "Business Cooperation",
  "日程表下载": "Download the schedule",
  "结果": "Result",
  "频道共有x个": "<strong>{count}</strong> channels found",
  "最近更新": "Latest",
  "按成员数": "Sort by members",
  "按视频数": "Sort by videos",
  "没有匹配的频道": "No channel matched your search",
  "搜索框内容不能为空": "Search keyword required",
  "创作者共有x位": "<strong>{count}</strong> creators found",
  "没有匹配的创作者": "No creator matched your search",
  "活动共有x个": "<strong>{count}</strong> events found",
  "没有匹配的活动": "No event matched your search",
  "模拟": "simulate",
  "键": "key",
  "已关注": "Following",
  "视频列表": "Video list",
  "视频数据": "Video data",
  "监听": "listen",
  "滑动": "slide",
  "是否取消关注": "Do you want to unfollow",
  "提示": "Notice",
  "离开成功": "Unsubscribed",
  "创建比赛": "Create a contest",
  "创建活动": "Create an Event",
  "竞赛小助手": "Contest CSR",
  "现未来": "Prefuture",
  "报名中": "In progress",
  "编辑活动": "Edit",
  "发起活动需要是认证的企业用户": "Verify before launching an event",
  "暂时没有任何活动": "No event available",
  "原手机号": "Legacy mobile",
  "原邮箱": "Old email",
  "输入新邮箱地址": "Please enter your new email",
  "输入邮箱地址": "Please enter your email",
  "输入新的手机号": "Please enter a new phone no.",
  "旧密码": "Old",
  "请输入旧密码": "Please enter old password",
  "新密码": "New",
  "手机": "Mobile",
  "请将原账号补充完整": "Please complete the original account info",
  "请填写旧密码和新密码": "Please enter old and new passwords",
  "已经被绑定到账号": "Already linked to the account",
  "个账号": "accounts",
  "你可以选择将该": "You can make the ",
  "从": "from",
  "个账号中解绑": "unlinked from the account",
  "并绑定到当前账号": "and link to current account",
  "原账号": "Legacy account",
  "未绑定任何邮箱和第三方账号": "haven't linked to any email or 3rd party account",
  "解绑后": "after unlinked",
  "将永远无法再登录": "will never be able to log back in",
  "你将无法再通过该手机号登录原账号": "You won't be able to log in to the original account with this number",
  "未绑定任何手机号和第三方账号": "haven't linked to any mobile or 3rd party account",
  "你将无法再通过该邮箱登录原账号": "You won't be able to log in to the original account with this email",
  "申请创建频道": "Create a channel",
  "默认排序": "Sort by default",
  "联系我们": "Contact us",
  "投稿须知": "Upload notice",
  "常见问题": "FAQ",
  "版权声明": "Copyright",
  "法律责任": "Legal claim",
  "内容制作中": "Under construction...",
  "申请创建": "Add",
  "报名通道": "Enroll",
  "赛事介绍": "Introduction",
  "装置": "Installation",
  "投影": "Projection",
  "联系方式": "Contact",
  "赛事概览": "Overview",
  "历届获奖作品": "Award winned works",
  "奖项设置": "Awards",
  "参赛说明": "Description",
  "团队名称或个人姓名": "Organization or personal name",
  "立即验证": "Proceed to verify",
  "邮箱格式不正确": "Invalid email",
  "请选择": "Please select",
  "手机格式不正确": "Invalid phone number",
  "验证码不正确": "Wrong verification code",
  "我已同意": "I have approved",
  "本次大赛参加规则等所有条款": "all the rules & terms of this contest",
  "确认报名": "Enroll",
  "发送验证码": "Send code",
  "未选择大赛规则": "You haven't agreed to the rules & terms",
  "请选择国家": "Please select a country",
  "已发送": "Sent",
  "重新获取": "Send again",
  "个性签名": "About",
  "用户介绍": "Bio",
  "排序": "Sort",
  "观看更多": "Views",
  "评论最多": "Comments",
  "原创": "Original",
  "非原创": "Non-original",
  "条筛选结果": " results",
  "作品集和点赞": "Collections and likes",
  "关注和麻酱": "Followers",
  "关注状态": "Follow status",
  "加载数据": "Loading data",
  "没有作品集": "No collection available",
  "没有点赞记录": "You haven't liked anything",
  "没有关注记录": "You haven't followed anything",
  "没有创作者记录": "No creator available",
  "的主页": "'s home page",
  "右侧": "Right",
  "上传头像": "Upload",
  "设置昵称": "Nickname",
  "设置新密码": "Set new password",
  "完成注册": "Register",
  "完善资料": "More info",
  "设置资料": "Set your info",
  "请输入昵称": "Please enter your nickname",
  "昵称不能有表情符号等特殊字符": "Nickname should not contain special characters like emoji",
  "请输入密码": "Please enter password",
  "密码位数不小于7位，不能为纯数字": "Password must be more than 6 character and include letters",
  "密码不少于7位，且不能为纯数字": "More than 6 characters & include letters",
  "找回密码": "Forgot password",
  "修改昵称": "Change nickname",
  "上传图片大小不能超过": "The image must be no more than",
  "头像更新成功": "Avatar updated",
  "在这里应该返回上一页": "Click to return to previous page",
  "请填写昵称": "Please enter your nickname",
  "注册成功": "Registered",
  "请完善个人信息": "Complete your info",
  "手机号注册": "Mobile",
  "邮箱注册": "Email",
  "注册即表示同意": "Approve on registration",
  "立即登录": "Log in now",
  "立即去注册": "Register now",
  "邮箱不能为空": "Email required",
  "不是有效的邮箱地址": "Invalid email",
  "密码不能为空": "Password required",
  "验证码不能为空": "Verification code required",
  "请输入正确的6位验证码": "Please enter 6 digit verification code",
  "已存在该账号": "Account already exists",
  "请直接登录": "Please log in now",
  "发送失败": "Sent failed",
  "该账户已存在": "Account already exists",
  "三方登录": "3rd party log in",
  "老账号": "Legacy account",
  "是否绑定手机号": "Proceed to link your mobile",
  "已绑定手机号": "Mobile already linked",
  "验证昵称重复否": "Check if the nickname exists",
  "不重复": "valid",
  "修改昵称页面": "Change your nickname",
  "未绑定手机号": "Phone no. unlinked",
  "绑定手机号页面": "Link your mobile phone",
  "手机号存在": "Phone no. exists",
  "手机号已绑定微信": "The phone number already linked to a Wechat account",
  "绑定失败": "Link failed",
  "这个手机号已经绑定其他微信用户": "This number's already connected to other Wechat account",
  "手机号未绑定微信": "This number's not connected to any Wechat account",
  "创建新账号": "Create new account",
  "绑定手机": "Claim your phone",
  "新用户": "New user",
  "昵称不重复": "Nickname already exists",
  "绑定成功": "Linked successfully",
  "微信": "Wechat",
  "微博": "Weibo",
  "账号中解绑": "disconnect  from this account",
  "你将无法再通过该微信登录原账号": "you won't be able to log in to the original account with this wechat account",
  "未绑定任何手机号和邮箱": "hasn't claimed any mobile phone or email",
  "邮箱找回": "by email",
  "手机号找回": "by phone",
  "${time}s后可重新获取": "Get in ${time}s",
  "该账号不存在": "The account doesn't exist",
  "频道设置": "Channel setting",
  "名称和分类": "Name & Tags",
  "简介和背景图": "Brief & Icon",
  "设置": "Settings",
  "视频管理": "Videos",
  "活动管理": "Events",
  "频道达人": "Contributors",
  "相关频道": "Related Channels",
  "基本设置": "Basic setting",
  "外观设置": "Appearance",
  "按钮": "Button",
  "保存设置": "Save",
  "返回频道": "Return to channel",
  "保存成功": "Saved",
  "缩略图": "Thumbnail",
  "选择哪个缩略图代表该频道": "Select a thumbnail for this channel",
  "重新选择图片": "Select another image",
  "频道内背景大图": "Channel background image",
  "您的图片会出现在组顶部": "Your image would appear in the top of the group",
  "这使得你的频道变得独一无二": "this will make your channel unique",
  "推荐图片尺寸": "recommended dimensions",
  "像素": "pixels",
  "最新的缩略图": "Latest thumbnail",
  "最近添加视频的缩略图": "Newly added video thumbnail",
  "自定义上传": "Custom upload",
  "上传自定义缩略图": "Upload custom thumbnail",
  "主持团": "Host",
  "达人": "Stars",
  "没有成员": "No members",
  "编辑视频": "Edit",
  "返回": "Return",
  "按照编号排序": "Sort",
  "编号": "Sequence",
  "热门": "Hot",
  "热 门": "Hot",
  "最新": "Latest",
  "文章": "Articles",
  "问答": "Q&A",
  "没有相关的讨论": "Related discussion not available",
  "搜索本组讨论": "Search in this channel",
  "组内成员": "Members",
  "加组时间": "joined",
  "频道内搜索你想找的成员": "Search a member in this channel",
  "频道名称": "Name",
  "请输入频道名称": "Please enter channel name",
  "请输入频道的简介": "Please enter channel brief",
  "这个是必填栏": "This is a required field",
  "保存": "Save",
  "创建成功": "Created",
  "保存频道": "Save",
  "请选择图片上传：大小1160 * 330像素支持JPG、PNG等格式，图片需小于2M": "Please select an image to upload, 1160 * 330 pixels, less than 2M and  JPG、PNG etc. supported.",
  "请选择图片上传：大小1160 * 300像素支持JPG、PNG等格式，图片需小于2M": "Please select an image to upload, 1160 * 300 pixels, less than 2M and  JPG、PNG etc. supported.",
  "请选择图片上传：大小140 * 140像素支持JPG、PNG等格式，图片需小于2M": "Please select an image to upload, 140 * 140 pixels, less than 2M and  JPG、PNG etc. supported.",
  "顺序": "Order ",
  "图片": "Image",
  "图 片": "Images",
  "创建日期": "Created date",
  "在线": "Online",
  "下线": "Offline",
  "上线": "Online",
  "添加": "Add",
  "重新选择": "Change",
  "链接地址": "Url",
  "确定删除此banner吗": "Confirm to delete this banner?",
  "数据": "data",
  "操作成功": "Success",
  "操作失败": "Failed",
  "个频道活动": " channel events",
  "初始状态": "Initial state",
  "新增": "Add",
  "编辑状态": "Edit state",
  "全选": "All",
  "按序号排序": "Order by number",
  "活动选择": "Select an event",
  "搜索活动": "Search for events",
  "已添加": "Added",
  "已选择": "Selected ",
  "个活动": " events",
  "非弹窗分页": "Non-popup paginaton",
  "弹窗分页": "Pop-up pagination",
  "选择添加一个活动": "Select an event",
  "确定添加": "Confirm",
  "请选择要添加的活动": "Please select an event",
  "添加失败": "Failed to add",
  "排序成功": "Sorted successfully",
  "请选择要删除的活动": "Please select the event to delete",
  "删除失败": "Failed to delete",
  "标签相关": "Tag related",
  "视频共有x部": "<strong>{count}</strong> videos in total",
  "没有匹配的视频": "There isn't matched video",
  "热门上传": "Hot",
  "一天内": "Today",
  "一周内": "This week",
  "一月内": "This month",
  "一年内": "This year",
  "热门标签": "Hot tags",
  "小时前": "hours ago",
  "提交成功": "Submitted",
  "点赞成功": "Liked",
  "取消点赞成功": "Unliked",
  "评论列表": "Comment list",
  "活动标题": "Event title",
  "请输入活动标题": "Please enter the event title",
  "活动报名时间": "Event participation time",
  "活动举办时间": "Event time",
  "购票链接": "Purchase",
  "报名链接": "Sign Up",
  "请输入购票链接": "Please enter the url to buy ticket",
  "活动封面": "Cover image",
  "上传图片请控制在3M以内": "The image should be less than 3M",
  "上传图片比例为": "The image ratio is",
  "修改": "Modify",
  "活动图片": "Event photos",
  "上传图片个数最大为12": "12 images at most",
  "活动标题不能为空": "Event title's required",
  "请选择专业": "Please select a profession",
  "请选择行业": "Please select an industry",
  "请上传图片封面": "Please upload cover image",
  "请输入": "Please enter ",
  "超出图片上传个数限制": "exceeds allowed image amount",
  "上传图片成功": "The photo was successfully uploaded",
  "保存后清空内容": "Clear the content after save",
  "请上传活动封面": "Please upload the event cover image",
  "请上传活动图片": "Please upload event photos",
  "预留分页器": "Save for pagination",
  "预留分页接口": "Saved for pagination interface",
  "添加热门": "Add as hot",
  "是否原创": "Original",
  "获取参数": "Get params",
  "初始化数据": "Initialize data",
  "15分钟前加组": "added 15 minutes ago",
  "比赛": "Contest",
  "学校": "School",
  "投稿活动": "Submit work",
  "全部活动": "All events",
  "江南校友十周年纪念活动": "Jiangnan University alumni 10 year's anniversary",
  "江南大学": "Jiangnan University",
  "离开频道组": "Leave the channel",
  "审核中": "Pending verification",
  "离开频道后": "After leaving this channel",
  "离开频道": "Leave the channel",
  "已取消删除": "Revoked",
  "企业号": "Enterprise account",
  "没有关注的创作者": "You haven't followed any creator",
  "没有关注的企业号": "You have followed an enterprise account",
  "官方": "Official",
  "最近播放": "Latest",
  "清空历史记录": "Clear history",
  "没有播放记录": "There isn't any watch history",
  "确认清空播放记录吗": "Do you want to clear watch history",
  "我的订阅": "Subscription",
  "订阅的行业": "Subscribed industry",
  "讨论区内容": "Discussion content",
  "审核通过": "Verified",
  "不通过": "Verification failed",
  "已删除": "Deleted",
  "视频已提交": "Your video has been submited",
  "请耐心等待审核": "thanks!",
  "查看视频": "View videos",
  "推荐竞赛": "Recommended contests",
  "投稿": "Enroll",
  "已审核": "Published",
  "待编辑": "Pending edit",
  "没有相关的视频": "Related video not available",
  "确认删除视频吗": "Confirm to delete this video?",
  "该视频处于大赛中": "The video's already in the contest",
  "不可删除": "Cannot delete",
  "不可编辑": "Not editable",
  "赛事背景": "Background",
  "征集对象": "Target",
  "参赛者可以个人或团队名义提交作品": "You may submit work as an individual or a team",
  "人工智能": "Artificial intelligence",
  "参赛要求": "Requirements",
  "邮箱及手机": "Email & mobile",
  "中英文创作者": "Creator",
  "团队介绍": "Team intro",
  "创作者真实姓名": "Real name",
  "参赛时间": "Contest time",
  "公开征集作品截止日期": "Open till",
  "北京时间": "Beijing time",
  "入围名单公布": "Entries publish on",
  "入围作品将通过赛事官方网站平台公布": "Entries will be published on the contest organizer's official website",
  "每项奖金": "Award bonus",
  "奖项说明": "Award description",
  "奖杯": "Trophy",
  "证书": "License",
  "评审团队": "Judge team",
  "创意监制": "Creative director",
  "举办单位": "Organizer",
  "主办方": "Organizer",
  "组委会成员": "Commitee member",
  "赞助方": "Sponsors",
  "合作方": "Partners",
  "特别支持方": "Specially supported by",
  "官方网站": "Official website",
  "记住我": "Remember me",
  "忘记密码": "Forgot password",
  "其他方式": "Other",
  "账号不能为空": "Email/mobile required",
  "请输入正确的邮箱或手机号": "Please enter valid email or mobile phone number",
  "是不是国外手机号": "Oversea mobile",
  "密码至少6个字符": "6 characters at least",
  "申请加入": "Apply",
  "热门文章": "Hot Articles",
  "更多": "More",
  "问题": "Question",
  "提问": "Ask",
  "发表见解": "Share your views",
  "分享知识": "Share knowledge",
  "精确描述问题": "Describe your question precisely",
  "得到解答": "get answers",
  "登陆弹窗": "Login pop-up",
  "输入账号": "Enter your account",
  "输入密码": "Enter your password",
  "没有账号": "Haven't got an account",
  "点击注册": "Click to register",
  "第三方登陆": "3rd party log in",
  "请输入账号": "Please enter your account",
  "用户名或密码错误": "Wrong user name or password",
  "非本频道成员无法提出问题": "Join the channel before ask questions",
  "是否关注此频道继续": "do you want to follow this channel and continue",
  "关注成功": "Followed",
  "已取消关注": "Unfollowed",
  "登陆": "Login",
  "背景图": "Background image",
  "截图": "crop",
  "成员选择": "Member",
  "搜索成员": "Search for members",
  "个达人": " stars",
  "请选择要删除的达人": "Please select the stars to delete",
  "请选择要添加的达人": "Please select the star to add",
  "达人信息列表": "Star info list",
  "个频道": " channels",
  "弹窗": "Popup",
  "选择频道": "Select a channel",
  "搜索频道": "Search from channel",
  "搜索字段": "Search fields",
  "请选择要删除的频道": "Please select the channel to delete",
  "请选择要添加的频道": "PLease select the channel to add",
  "添加后刷新": "Refresh after adding",
  "行业分类": "Industries",
  "切换背景图片": "Switch background image",
  "频道推荐": "Top channels",
  "每日推荐": "Recommended",
  "添加至频道": "Add to channel",
  "立刻登录，享受更多功能": "<a href='/login'>Register/login</a> now to enjoy more features",
  "添加订阅": "Subscribe",
  "活动推荐": "Recommended events",
  "优秀创作者": "Top creators",
  "参与的活动": "Participated events",
  "发起的活动": "Created events",
  "没有参与的活动": "You haven't participated in any event",
  "没有发起的活动": "You haven't created any event",
  "我参加的竞赛": "Participated contests",
  "竞赛名称": "Name",
  "竞赛状态": "Status",
  "参赛结果": "Result",
  "去支付": "Pay",
  "退出竞赛": "Quit",
  "没有参与的比赛": "You haven't participated in any contest",
  "确定退出竞赛": "Confirm to quit contest",
  "获奖作品公布": "Winners published",
  "未支付": "Unpaid",
  "投稿失败": "Submit failed",
  "待支付": "Pending payment",
  "未入围": "Not accepted",
  "未获奖": "Missed the award",
  "已入围": "Accepted",
  "已获奖": "Winner",
  "没有收藏记录": "Favorite not available",
  "取消点赞": "Unlike",
  "以下信息仅用于竞赛，我们将严格保密（个人介绍和所在地除外）": "The following info's only for the contest, we won't uncover(intro & location excluded)",
  "请输入真实姓名": "Please enter your real name",
  "去绑定": "Proceed to link",
  "如需更换请前往": "To change it, please go to",
  "国籍": "Nationality",
  "请选择国籍": "Please select nationality",
  "请输入个人简介": "Please enter bio",
  "请输入个人/团队简介": "Please enter introduction",
  "所在地": "Location",
  "请选择省份": "PLease select the province/state",
  "请选择城市": "Please select the city",
  "请输入毕业/所在院校": "Please enter the university you're studying at/graduated from",
  "已毕业": "Graduated",
  "在读学生": "Reading students",
  "在读": "Student",
  "请输入职业": "Please enter your occupatin",
  "职位": "Job",
  "请输入职位": "Please enter your job",
  "请先绑定手机号": "Please link your mobile first",
  "请先绑定邮箱": "Please link your email first",
  "最多输入2000个字符": "2000 characters at most",
  "最多输入100个字符": "100 characters at most",
  "总计": "Total",
  "参赛作品评选费基本费用": "Charge for reviewing",
  "不包含展示费和得奖者服务费": "it doesn't include service charge and fees for public presentation",
  "支付方式": "Payment",
  "线下支付": "Offline payment",
  "转账请备注": "Upon transfer, include",
  "注册邮箱": "registered email",
  "参赛方": "Contest party",
  "转账人": "Remitter",
  "作为报名支付成功的唯一凭证": "as the only payment credential",
  "户名": "Account name",
  "开户行": "Bank",
  "账号": "Account",
  "外币": "Foreign currency",
  "人民币": "RMB",
  "开具发票": "Invoice",
  "普通发票": "Common invoice",
  "专用发票": "Special invoice",
  "发票抬头": "Invoice to",
  "发票税号": "Tax no.",
  "公司地址": "Address",
  "公司电话": "Telephone",
  "收件人地址": "Recipient's Address",
  "收件人电话": "Recipient's Phone No.",
  "收件人姓名": "Recipient's Name",
  "备注": "Note",
  "开票内容为报名费": "Invoice item is entry fee",
  "发票快递为到付": "the invoice is paid on delivery",
  "报名支付如有问题": "If you should ever have any question",
  "请联系": "Please contact",
  "恭喜你": "Congratulations",
  "请于3个工作日内完成线下支付": "Please complete the offline payment in 3 days",
  "支付完成审核后即为投稿成功": "the submit would be completed once the payment's confirmed",
  "请填写发票抬头": "Please enter the invoice-to party",
  "请填写收件人地址": "Please enter the address",
  "请填写收件人电话": "Please enter the phone number",
  "请填写收件人姓名": "Please enter the recipient's name",
  "请填写发票税号": "Please enter tax number",
  "请填写开户行": "Please enter your bank",
  "请填写账号": "Please enter the account number",
  "请填写公司地址": "Please enter your company address",
  "请填写公司电话": "Please enter your company telephone",
  "请选择支付方式": "Please select a payment method",
  "用户邮箱": "User email",
  "订单数量": "Quantity",
  "单价国内": "domestic price",
  "海外": "oversea",
  "参赛作品不可在参赛期间自行删除": "You can't delete the video during the contest",
  "如需修改参赛信息": "if you wish to change the info",
  "可在个人中心": "please go to My Account",
  "我的竞赛下点击": "click under My Contest",
  "进行修改": "to change",
  "团队名称": "team name",
  "以下设计项目信息默认在成功设计大赛官网公开展示，如不希望公开，可在下方选择不公开": "Project info would show at Successful Design official website by default, you may select Private to hide it from the public",
  "作品价值": "Value of the work",
  "这个作品为用户提供了什么价值": "What's the value for users",
  "参考": "e.g.",
  "这个作品着重在···(功能创新、情感连接、审美、用户体验···)进行了深入地思考，并做了···的尝试/改进/改革": "This work involves deep thoughts in...(innovation, sentimental connection, aesthetic, user experience), and made tries/improvements/revolutions in...",
  "请填写中文版": "in Chinese",
  "请填写英文版": "in English",
  "不公开": "Private",
  "商业表现": "commercial performance",
  "这个作品在商业上有什么表现": "What is the commercial performance of this work",
  "该作品在发布后的···时间内，在（市场销量/占有率，传播价值，品牌知名度···）方面获得了···的成绩": "After .. of  the release of this work, there were achievements in ...(sales/market share, broadcasting & branding value )",
  "社会影响": "Social impact",
  "这个作品为社会带来了什么价值": "What was the social impact of this work",
  "该作品改变了···的现状/推进了行业向···方向发展/对文化发展起到了···作用/在可持续发展方面发挥了···作用": "This work changed the state of .../ pushed the industry in the direction of... / had ... impace in cultural development/ ... impact in sustainable development",
  "团队组织": "Team & organization",
  "有哪些人参与了这个作品": "How many people involved in this work",
  "他们在过程中的角色是": "and what were their roles",
  "这个作品一共有···位全职成员参与": "There were ... full-time members",
  "他们分别负责···（设计、结构、策划、市场···）；公司内部/客户方负责···的部门在项 目的···阶段介入给予···的帮助；外部的···（专家、用户、KOL）也在作品的···阶段 介入，担任了···角色": "They were in charge of ... (design, architecture, planning, marketing...) respectively; the ... department of the company/client offered ... assistance in ...; external ...(experts, users, KOL) played ... role in ... phase of this work",
  "流程方法": "Process & method",
  "在作品流程中有哪些创新点": "How many innovations in the work?",
  "这个作品之所以能够达到": "This work can reach",
  "超越预期的目标": "exceed the expected goal",
  "是因为流程中我们 在···（流程管理、工具方法、执行过程）方面做了··": "the reason behind it was we did ... (process management, tools & methods, delivery process) in ...",
  "作品投入": "Investment",
  "该作品从设计到交付，花费了 多少时间？参考：": "From design to delivery, how much time it took? e.g.",
  "该作品从立项到设计交付，花费了多少时间？总共 有多少投入？": "From the beginning of this project to its delivery, how much time it took? And what's the total investment?",
  "达成情况": "Performance",
  "该作品的目标是什么，结果和预期是否一致？参考：": "Object of the work, was the outcome in line with your expectation? e.g.",
  "做这个作品的初心是为了···，最终的结果 在···方面取得了出乎预料的表现": "The initial thought for this work was..., finally got unexpected performance in terms of ...",
  "做这个作品是为了遵循公司的···战略，作品最终对于这个 战略 的推动意义是···": "The work followed our company strategy ..., it helped to promote this strategy in terms of ...",
  "我已同意本次赛事参赛条款及细则": "I've agreed to the contest terms & policies first",
  "请填写团队名称": "Please enter your team name",
  "请填写用户价值": "Please enter its value to users in Chinese",
  "请填写英文用户价值": "Please enter its value to users in English",
  "请填写商业表现": "Commercial outcome in Chinese",
  "请填写英文商业表现": "Commercial outcome in English",
  "请填写社会影响": "Social impact in Chinese",
  "请填写英文社会影响": "Social impact in English",
  "请填写团队组织": "Team & organization in Chinese",
  "请填写英文团队组织": "Team & organization in English",
  "请填写流程方法": "Procedure in Chinese",
  "请填写英文流程方法": "Procedure in English",
  "请填写项目投入": "Project invest in Chinese",
  "请填写英文项目投入": "Project invest in English",
  "请填写达成情况": "Achievement in Chinese",
  "请填写英文达成情况": "Achievement in English",
  "请先同意本次赛事参赛条款及细则": "Please agree to the contest terms & policies first",
  "推荐人": "Recommended by",
  "视频选择框": "Video selection box",
  "视频选择": "Video selection",
  "搜索视频": "Search for videos",
  "视频审核": "Pending review",
  "获取所有视频": "Get all videos",
  "请选择要添加的视频": "Please select an video",
  "选择添加一个视频": "Please select an video to add",
  "请选择要删除的视频": "Please select an video to delete",
  "近期热门": "Hot",
  "分享给朋友": "Refer to a friend",
  "分享到新浪微博": "Share to Weibo",
  "分享到微信": "Share to Wechat",
  "推荐": "Recommend",
  "将视频贴到博客或论坛": "Paste to blog or forum",
  "通用代码": "Code",
  "复制": "Copy",
  "制作软件": "Softwares",
  "浏览量": "Views",
  "其它协作者": "Other collaborators",
  "专业比赛": "Professional contest",
  "本作品已参赛": "This work's already in contest",
  "已复制": "Copied",
  "交互设计": "Interactive design",
  "装置空间": "installation space",
  "公共艺术": "Public art",
  "专业标签词": "professional tags",
  "制作软件词": "softwares",
  "相关视频": "Related videos",
  "提交商务合作需求": "Submit for business partnership",
  "基本信息": "Basic info",
  "格式": "Format:",
  "文件大小": "File size",
  "图片比例": "Image ratio ",
  "尺寸": "Size",
  "上传封面": "Upload cover image",
  "最多选择5个": "No more than 5",
  "最多选择3个": "No more than 3",
  "举办地点": "Location",
  "选择城市": "Select a city",
  "输入地址": "Please enter the address",
  "参与方式": "Channel",
  "门票价格": "Ticket price",
  "例如": "e.g.",
  "报名": "Enroll",
  "更多设置": "More settings",
  "选填": "Optional",
  "输入标签": "Add a tag",
  "参与人员": "Entrants",
  "选填，可以填写艺术家、策展人、主办方等参与人员": "Optional, artist, curator, organizer or other participants",
  "在活动中的角色": "Role in the event",
  "选填，图片不超过3M": "Optional, 3M at most",
  "活动详情": "Event details",
  "保存草稿": "Save to draft",
  "购票": "Buy ticket",
  "活动标题不能超过40个中文字符": "Event title must be 80 characters at most",
  "请选择活动类型": "Please select the event type",
  "请输入地址": "Please enter your address",
  "请输入报名/购票链接": "Please enter registration/ticket link",
  "报名/购票链接": "Registration/ticket link",
  "国内": "Domestic",
  "价格": "Price",
  "请填写活动详情": "Please enter event detail",
  "保存草稿成功": "Saved to draft successfully",
  "创建频道": "Create a channel",
  "编辑频道": "Edit channel",
  "解散频道": "Delete channel",
  "头部导航": "Top navigation",
  "主页": "Home",
  "收藏": "Collect",
  "发布的讨论": "Published discussions",
  "查看全部": "View all",
  "回复的讨论": "Replied discussions",
  "点赞的讨论": "Liked discussions",
  "收藏的讨论": "Favorite discussions",
  "来自": "from",
  "的讨论区": "discussion area",
  "问答详情": "Q&A detail",
  "写下你的回复": "Share your answer",
  "是否确定删除": "Do you really want to delete it",
  "返回到上个页面": "return to previous page",
  "您没有权限删除": "You're not authorized to delete",
  "回复成功": "Replied",
  "请等待人工审核": "Please wait for verification by our staff",
  "个人认证": "Personal verification",
  "企业认证": "Corporate verification",
  "你的个人认证信息已审核通过": "Your personal info's being verified",
  "恭喜你成为我们尊贵的个人认证会员": "Congratulations for being our honorable individual verified member",
  "个人认证信息审核中": "Pending personal verification",
  "你的企业认证信息已审核通过": "Your organization's verified",
  "恭喜你成为我们尊贵的企业认证会员": "Congratulations for being our honorable corporation verified member",
  "信息认证": "Verification",
  "必填": "Required",
  "请输入姓名": "Please enter your name",
  "身份证": "ID card",
  "位身份证号码": "-digit ID card no.",
  "请选择地区": "Please select your region",
  "请输入城市": "Please enter your city",
  "请输入手机号": "Please enter your phone number",
  "请输入验证码": "Please enter the verfication code",
  "上传证件照": "Upload ID photo",
  "上传证件照正面": "ID card front image",
  "点击上传": "Upload",
  "上传证件照反面": "Upload ID card back image",
  "证件要求": "Requirements",
  "需上传本人露脸手持二代身份证照片＋身份证反面照片（不需手持）": "Need to hold the ID card and take a photo + back view of the ID card(no need to hold it)",
  "身份证反面照片": "ID card back image",
  "证件必须在有效期内，有效期需在一个月以上": "the ID card must be valid in one month",
  "照片要求": "Photo requirements",
  "文字清晰可辨": "Text can be clearly seen",
  "证件照上信息需完整且清晰可辨（无反光、遮挡、水印、证件套、logo等）": "Keep the info on the ID card intact and clear(not covered, watermarked etc.)",
  "遮挡": "covered",
  "水印": "watermarked",
  "申请人填写的“公司名称”需和提交证件照片信息一致": "\"Company Name\" should be the same as the uploaded license",
  "证件必须真实拍摄，不能使用复印件，不能对镜（证件信息反转）拍摄": "Please do not use a copy or mirrored license",
  "拍摄": "Camera",
  "确保照片完整": "Keep the photo intact",
  "确保照片完整（不缺边角），证件周围不允许加上边角框（如：加上红框等）": "Keep the photo intact(all corners included), no frame around the corner",
  "提交认证": "Submit",
  "企业认证信息审核中": "Business verification underway",
  "企业信息": "Company info",
  "企业信用代码": "Company registration no.",
  "请输入企业信用代码": "Please enter company registration no.",
  "需上传企业工商营业执照": "You need to upload business license",
  "组织机构代码证照": "Organization code certificate",
  "商标注册证或商标注册受理通知书": "Certificate of trademark registration",
  "组织机构代码证上传证件照": "Organization code certificate",
  "工商营业执照上传证件照": "Business license photo",
  "营业执照照片或扫描件": "Business license photo",
  "请输入身份证号码": "Please enter your ID number",
  "身份证格式不正确": "Invalid ID number",
  "请输入所在城市": "City",
  "手机号格式不正确": "Invalid mobile number",
  "请上传": "Please upload",
  "以内的图片": "at most",
  "请上传证件照正面": "Front image",
  "请上传证件照反面": "Back image",
  "手机号已修改": "Mobile phone modified",
  "请重新获取验证码": "please get a new verification code",
  "请上传执照": "Please upload your business license",
  "重新发送": "Resend",
  "上传视频": "Upload",
  "支持格式": "Accepted format",
  "文件大小限制": "Maximum file size",
  "并同意遵守《MANA原创/授权视频声明用户规范》、《MANA法律责任》": "Agree to follow our terms & policy",
  "帮助说明": "Instruction",
  "视频正在上传": "Uploading the video",
  "视频基本信息": "Basic video info",
  "请输入作品名字": "Please enter the name of the work",
  "作品类型": "Type",
  "原创标签需要": "Original tag requires",
  "后进行设置": "configure later",
  "其他创作者": "Other creators",
  "请上传作品封面": "Please upload a cover image",
  "添加标签": "Add a tag",
  "添加标签可以把作品自动推荐给可能感兴趣的人": "Add a tag to remmend your work to people interested",
  "作品标签": "Tags",
  "空格或回车添加作品标签": "Press enter or space to add more tags",
  "请输入标签": "Please enter tags",
  "贴标签": "Tag",
  "选择行业和专业": "Select industry & profession",
  "可以把作品自动归类到对应的行业和专业": "You may categorize to corresponding industry and profession automatically",
  "更多信息设置": "More settings",
  "作品是否允许被下载": "Allow download",
  "请输入装备标签": "Enter devies tags",
  "投稿至比赛": "Enroll in a contest",
  "不投稿": "Don't enroll",
  "预览": "Preview",
  "记得改为": "Remember to change to",
  "标签内容不能为空": "Tags required",
  "标签内容不能重复": "Duplicate tag",
  "标签个数超过上限": "More tags than allowed",
  "不可重复添加": "already being added",
  "请先进行个人认证": "Please proceed to personal verification first",
  "上传失败": "Upload failed",
  "上传成功": "Upload successfully",
  "视频正在转码中": "Video encoding",
  "视频上传成功": "Video uploaded successfully",
  "验证": "Verify",
  "视频名称不能为空": "Video title required",
  "请选择是否原创": "Original",
  "视频简介不能为空": "Video description required",
  "请上传作品图片": "Please upload images of your work",
  "请选择是否允许被下载": "Allow download",
  "查看全部简介": "View all",
  "相关活动": "Related events",
  "热门活动": "Hot Events",
  "讨论区域": "Discussion area",
  "右侧区域": "Right area",
  "没有相关的活动": "Related events not available",
  "频道公告": "Channel notifications",
  "去看看": "Dig around",
  "第三方登录": "Third party login",
  "删除多余": "Remove redundancies",
  "文本编辑器": "Text editor",
  "登陆方式": "Log in method",
  "个人资料": "Profile",
  "账号安全": "Security",
  "仅自己可见": "Visible to myself only",
  "昵称": "Nickname",
  "请填写真实姓名": "Your real name",
  "选择日期": "Select a date",
  "请输入个性签名": "Please enter about",
  "个人简介": "Bio",
  "请输入个人介绍": "Your intro",
  "教育背景": "Education",
  "学校名称": "University",
  "请输入院校": "Your university",
  "请填写微信号": "Wechat ID",
  "所有人": "Visible to all",
  "请填写": "Please fill in",
  "个人链接": "Links",
  "个人网站": "Website",
  "新浪微博": "Weibo",
  "密码修改": "Change password",
  "账号信息": "Account",
  "未绑定": "Unbound",
  "登录密码": "Password",
  "解绑": "Unlink",
  "邮箱修改": "Change",
  "创作领域最多只能选三个": "3 creative fields at most",
  "确定解绑": "Confirm to unlink ",
  "解绑成功": "Unlinked successfully",
  "已取消解绑": "Canceled",
  "修改手机号": "Change mobile",
  "修改邮箱": "Change email",
  "绑定邮箱": "Verify your email",
  "修改密码": "Change password",
  "请输入联系地址": "Please enter your address",
  "个人介绍不能超过2000字": "Personal intro should be less than 2000 characters",
  "输入框不能为空": "Input fields required",
  "个性签名不能超过": "About should not exceed ",
  "用户信息保存": "Save user info",
  "仅校验必填字段": "Only verify required fields",
  "个人简介不能超过": "Bio max characters",
  "请填写创作领域": "Please enter your creative fields",
  "请选择所在地": "Location",
  "链接保存": "Save link",
  "请按规范填写以下信息": "Enter the following per the rules",
  "邮件发送成功": "Email sent",
  "请及时查看邮件": "Please check your email now",
  "头像上传": "Upload profile picture",
  "新增保存创作领域": "Add and save create fields",
  "视频上传": "Upload video",
  "正在上传": "Uploading",
  "重新上传": "Change",
  "视频封面": "Cover images",
  "视频封面随机图": "Random video cover images",
  "系统默认可选封面": "Default cover images",
  "视频标题": "Title",
  "类型": "Type",
  "类 型": "Type",
  "上下拖拽可调整排序": "Drag &drop to order",
  "在作品中的角色": "Role in the work",
  "选择共同创作者": "Collaborators",
  "选择标签": "Tags",
  "其他标签": "Other tags",
  "填写丰富的标签有助于增加作品的曝光": "Tags will present your work to more users",
  "其他设置": "Other settings",
  "开放下载": "Open for download",
  "请仔细考虑是否愿意开放给所有": "Please take serious considerations on whether to allow",
  "注册用户": " registered users",
  "进行免费下载": "to download the video for free",
  "下载的视频将会带有": "Uploaded video will be with",
  "和": "and",
  "您的": "your ",
  "这将有利于您的作品在网络传播": "This will facilitate the broadcasting of your work",
  "被更多人看见": "viewed by more visitors",
  "查看示例": "See demo",
  "不开放": "Disallow",
  "开放": "Allow",
  "当前用户": "Current user",
  "其他工作设置": "Other work settings",
  "专业最多只能选": "prefessions at most",
  "行业最多只能选": "industries at most",
  "共同创作者已存在": "Collaborator already exists",
  "保存其它行业和专业": "Save other industries and professions",
  "新增行业不能为空": "Industry required",
  "新增专业不能为空": "Profession required",
  "新增其他标签不能为空": "Other tags required",
  "新增工作设置不能为空": "Empty work setting not allowed",
  "新增成功": "Successfully added",
  "添加行业标签": "Add industry tags",
  "为选中状态": "selected state",
  "清空当前变量": "clear current variant",
  "隐藏保存": "hide save button",
  "请检查上传格式是否符合支持格式": "Please check on your file format",
  "默认截取封面图": "Default cropped cover image",
  "第一帧": "1st frame",
  "随机": "random",
  "帧": "frames",
  "获取时长": "Duration",
  "随机两个图片": "2 random images",
  "视频名称英文不能为空": "English video title required",
  "视频简介英文不能为空": "English video description required",
  "其他标签处理": "Processing other tags",
  "添加新增数据": "Add new data",
  "缩列图": "Thumbnail",
  "处理": "Handle",
  "选择已发布的作品": "Choose from published works",
  "开始日期": "Start date",
  "结束日期": "End date",
  "MANA平台报名": "MANA",
  "最大购买数量不可小于0,且不可大于总票数": "Maximum ticket per person should be more than 0 and less than the total",
  "温馨提示：请谨慎判断并注意交易安全": "Caution: be careful with the transaction safety",
  "10M以内": "within 10M",
  "付费课程": "Paid Courses",
  "免费课程": "Free Course",
  "直播": "Live",
  "人已购买": " Sold",
  "学院": "Academy",
  "人感兴趣": " Interested",
  "还没有发布的作品": "No Works",
  "请输入标题和正文": "Please enter title and content",
  "帮助手册": "Manual",
  "隐私政策": "Privacy Policy",
  "线上线下活动详情": "Online & Onsite Event Details",
  "活动报名": "Event Registration",
  "比赛报名": "Contest Registration",
  "下载页": "Download Page",
  "用户中心": "User Center",
  "我的嘛酱": "My MANAJAM",
  "我的比赛": "My Contests",
  "消息中心": "Message Center",
  "2019“现未来”科技艺术之星奖-竞赛介绍": "2019 \"Present Future\" Art & Technology Star Award-Intro",
  "2019“现未来”科技艺术之星奖-获奖公示": "2019 \"Present Future\" Art & Technology Star Award-Awards",
  "2019“现未来”科技艺术之星奖-入围作品": "2019 \"Present Future\" Art & Technology Star Award-Entries",
  "2019“现未来”科技艺术之星奖-参赛作品": "2019 \"Present Future\" Art & Technology Star Award-Works",
  "竞赛首页": "Contest Homepage",
  "视频嵌入页": "Video Embed Page",
  "上海设计周先锋论坛": "date Shanghai Design Week Forum & Talk",
  "上传比赛视频": "Upload Contest Video",
  "发现视频": "Explore Videos",
  "发现创作者": "Explore Creators",
  "文章列表": "Article List",
  "邮箱认证": "Email Verification",
  "搜索页": "Search Page",
  "发起活动-竞赛": "Initialize Event-Contest",
  "授权": "Authorization",
  "页面未找到": "Page Not Found",
  "发现频道": "Explore Channels",
  "赛事资讯": "Broadcast",
  "景观设计": "Landscape Design",
  "动态设计": "Kinetic Design",
}



// WEBPACK FOOTER //
// ./src/languages/en/global.js